import enLocale from './en-US.json';
import zhLocale from "./zh-Cn.json";
import twLocale from "./zh-Tw.json";

export default {
    en: enLocale,
    zhCn: zhLocale,
    zhTw: twLocale,
}
